/* eslint-disable max-len */
import React from 'react';
import { withRouter, Switch, Route, Redirect, NavLink } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import SideScrollingTab from 'modules/common/components/SideScrollingTab';

import * as actions from './actions';
import * as c from './constant';

import TransactionContainer from './transactions/TransactionsContainer';
import ApplicationContainer from './applications/container/ApplicationContainer';
import SettingsContainer from './settings/SettingsContainer';

function eBPLSContainer({ match }) {
  const permissions = getJson('permissions');

  return (
    <>
      <div className="module-inner">
        <div className="module-inner-title">
          Electronic Business Permit and Licensing System
        </div>
        <SideScrollingTab dragToScroll hideScrollButtons>
          <div className="generic-module-nav">
            <NavLink
              exact
              className="nav-link"
              activeClassName="active"
              to="/ebpls/transactions"
            >
              Dashboard
            </NavLink>
            <NavLink
              exact={false}
              className="nav-link"
              activeClassName="active"
              to="/ebpls/applications"
            >
              Applications
            </NavLink>
            {Acl(permissions, ['VIEW EBPLS SETTINGS']) && (
              <NavLink
                exact={false}
                className="nav-link"
                activeClassName="active"
                to="/ebpls/settings"
              >
                Settings
              </NavLink>
            )}
          </div>
        </SideScrollingTab>
        <Switch>
          <Route
            path={`${match.path}/transactions`}
            component={TransactionContainer}
          />
          <Route
            exact
            path={`${match.path}`}
            render={() => <Redirect to={`${match.path}/transactions`} />}
          />
          <Route
            path={`${match.path}/applications`}
            component={ApplicationContainer}
          />
          <Route
            path={`${match.path}/settings`}
            component={SettingsContainer}
          />
        </Switch>
      </div>
    </>
  );
}

eBPLSContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  transactionListCount: _.get(api, `${c.GET_TRANSACTION_COUNTS}.res`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(eBPLSContainer);
